import { useTranslations } from 'next-intl';
import { IProduct } from '@monofront/types';
import { useAuthentication } from '@context/businessContainer';
import { HIDDEN_PRICE } from '@monofront/business/constants';
import { useFormatProductWeight } from '@monofront/business/hooks/product/useFormatProductWeight';
import { format, getMultipleProductCount } from '@monofront/business/utils';
import useProductComputedPricing from '@hooks/product/useProductComputedPricing';

interface IProductFormatProps {
  product: IProduct;
}

const ProductFormat: React.FC<IProductFormatProps> = ({ product }) => {
  const { isAuthenticated } = useAuthentication();
  const { formatProductWeight } = useFormatProductWeight();
  const tCatalog = useTranslations('Catalog');

  const isPriceHidden =
    !isAuthenticated &&
    product.tags.some((tag) => tag === HIDDEN_PRICE.STARTWITH);

  const productPricing = useProductComputedPricing(product);

  const { finance } = product.meta;
  const unitMeasurement = finance?.unit_of_measurement;
  const unitPrice = productPricing.unitPrice;
  const formattedProductWeight = formatProductWeight(finance, false);

  const multipleProductCount = getMultipleProductCount(product.tags);

  return (
    <p className="tw-mt-5">
      {formattedProductWeight && (
        <strong className="tw-font-semibold">{formattedProductWeight}</strong>
      )}
      {!isPriceHidden && unitMeasurement && unitPrice && (
        <span
          className={`tw-text-black-700 [strong+&]:tw-ml-2 [strong+&]:tw-border-0
          [strong+&]:tw-border-l [strong+&]:tw-border-solid [strong+&]:tw-border-blue-200 [strong+&]:tw-pl-2
        `}
        >
          {`${format(unitPrice)} / ${unitMeasurement}`}
        </span>
      )}

      {multipleProductCount && multipleProductCount >= 2 && (
        <span className="tw-lf-tag tw-lf-tag-md tw-lf-tag-accent tw-ml-5">
          {tCatalog('productMultiple', {
            number: multipleProductCount,
          })}{' '}
        </span>
      )}
    </p>
  );
};

export default ProductFormat;
